export { UniformEntryPageTemplate } from "./uniform-entry-page.template";
export { UniformEntryPageTemplate as default } from "./uniform-entry-page.template";
